import { useTranslation } from 'react-i18next';

interface AboutSectionProps {
  summary?: string
}

export function AboutSection({ summary }: AboutSectionProps) {
  const { t } = useTranslation();
  return (
    <div className="tc-mv-question-field p-4 rounded-2xl text-white space-y-2">
      <h2 className="text-xl font-semibold">{t('profile.about')}</h2>
      <p className="whitespace-pre-wrap">
        {summary || t('profile.noDescription')}
      </p>
    </div>
  )
}
